/**
 * attatchment模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const attatchment = {
  //通过ticketId查询附件
  selectByTicketId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/attatchment/selectByTicketId`,param);
  }
}

export default attatchment;



// WEBPACK FOOTER //
// ./src/api/attatchment.js